import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Form from "./Form";
import AwsForm from "./AwsForm";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Form />} />
          <Route path="/azure" element={<Form />} />
          <Route path="/azuresaas" element={<Form />} />
          <Route path="/aws" element={<AwsForm />} />
          <Route path="/awssaas" element={<AwsForm />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
